// extracted by css-extract-rspack-plugin
export default {"tooLargeWrapper":"Index-module__tooLargeWrapper__LJpIr"};